export const hasNonZeroBounds = (element) => {
  if (!element?.getBoundingClientRect) return false;

  const { width, height } = element.getBoundingClientRect();

  return width > 0 && height > 0;
};

const getElementWithVisibleBox = (element) => {
  let current = element;

  while (current?.getBoundingClientRect) {
    if (hasNonZeroBounds(current)) return current;

    current = current.parentElement;
  }

  return element;
};

export default getElementWithVisibleBox;
